import React, { Component } from "react";

export default class CardEntidadV2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      itemSelected: props.itemSelected,
      img: props.img,
      label: props.label,
      codigo: props.codigo,
      valorSeleccionado: ""

    };
  }

  componentDidMount() {

  }

  handleChange = (e) => {
    let valores = e.paymentServices;
    let pathEntidad = e.paymentEntityLogo;
    this.setState({
      valorSeleccionado: e.paymentEntityName
    });
    this.props.selectorValue(valores, e.paymentEntityName, pathEntidad );
  };


  render() {
    var valor = this.props.itemSelected;
  
    return (
      <div className="col-lg-2 col-6">
        <div className="info-box pago-servicio-caja" onClick={(e) => { this.handleChange(valor) }}>
          <span className="pago-servicio-caja-link">
            <div className="image">
              <img src={valor.paymentEntityLogo} className="pago-servicio-img" alt={valor.paymentEntityName}/>              
            </div>
            <p className="pago-servicio-img-label">{valor.paymentEntityName}</p>
          </span>
        </div>
      </div>
    )

  }
}


